import { render } from "./TotalTeachers.vue?vue&type=template&id=2e946750&ts=true"
import script from "./TotalTeachers.vue?vue&type=script&lang=ts"
export * from "./TotalTeachers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__